<template>
    <div>

        <config-main-title>
            Instruções Particular
        </config-main-title>

        <instrucoes-operadora ref="formulario" :id_operadora="1"></instrucoes-operadora>

    </div>
</template>

<script>
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import InstrucoesOperadora from './Operadora/InstrucoesOperadora.vue';

export default {
    data () { 
        return { 
            dados: null, 
        }
    },

    components: { 
        ConfigMainTitle,
        InstrucoesOperadora, 
    },

    mounted () { 
        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Instruções Particular", path: '/config/instrucoes-particulares' },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

}
</script>